import React, { useState, useEffect } from "react";

import HeaderComp from "./HeaderComp";
import SideBarComp from "./SideBarComp";

import {
  Divider,
  Input,
  Button,
  Icon,
  Menu,
  Table,
  Checkbox,
  Grid,
  Header,
  Radio,
  Image,
  Segment,
  Sidebar,
  Form,
} from "semantic-ui-react";
import { Route, Routes, Outlet } from "react-router-dom";
import {
  CreateCompany,
  ListCompany,
  ListUser,
  AddExpense,
  ListExpanse,
  NewInvoice,
  SpendMoney,
  ReciveMoney,
  ListInvoice,
  ListRecivedMoney,
  ListSpendMoney,
  DailyWorkList,
  CreateNewWork,
} from "../pages";
import FooterComp from "./FooterComp";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { BaseUrl, BaseUrlInvoice } from "../pages/formcomponents/Constants";

const ContainerComp = () => {
  const [visible, setVisible] = React.useState(false);
  const navigate = useNavigate();
  const [paymentNotification, setpaymentNotification] = useState([]);
  const [documentExpiry, setdocumentExpiry] = useState([]);
  const [tableType, settableType] = useState(0);
  const [radioValue, setradioValue] = useState();
  useEffect(() => {
    getExpiryPaymentList();
  }, []);
  const getExpiryPaymentList = () => {
    settableType(1);
    axios
      .post(BaseUrlInvoice + "/accounts/listPurchaseNearingPayment", {
        id: 1,
      })
      .then((res) => {
        console.log("Notification", res.data);
        setpaymentNotification(res.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getExpiryDocList = (val) => {
    setVisible(true);
    settableType(2);
    setradioValue(val);
    //accounts/listExpiringDocuments

    axios
      .post(BaseUrlInvoice + "accounts/listExpiringDocuments", {
        nofDaysToExpiry: val,
      })
      .then((res) => {
        //setRecordForTable(res.data);
        setdocumentExpiry(res.data);
        console.log("Expiry Doc", res.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  return (
    <div>
      <HeaderComp />
      <Sidebar.Pushable
        as={Segment}
        style={{
          marginTop: "30px",
          marginBottom: "50px",
        }}
      >
        <Sidebar
          as={Menu}
          animation="overlay"
          direction="right"
          inverted
          vertical
          visible={visible}
          style={{
            position: "fixed",
            width: "500px",
            backgroundColor: "white",
          }}
        >
          <Menu.Item
            as="a"
            header
            style={{ display: "flex", justifyContent: "space-between" }}
          >
            <div></div>
            <div
              style={{
                backgroundColor: "red",
                color: "white",
                padding: 10,
                fontWeight: "bold",
                fontSize: "20px",
                borderRadius: "3px",
              }}
              onClick={() => setVisible(false)}
            >
              X
            </div>
          </Menu.Item>
          <div
            style={{
              marginRight: "20px",
              marginLeft: "20px",
            }}
          >
            {tableType == 1 && (
              <Table celled fixed singleLine>
                <Table.Header>
                  <Table.Row>
                    <Table.HeaderCell
                      style={{
                        backgroundColor: "#337ab7",
                        color: "white",
                      }}
                    >
                      Company
                    </Table.HeaderCell>
                    <Table.HeaderCell
                      style={{
                        backgroundColor: "#337ab7",
                        color: "white",
                      }}
                    >
                      Amount
                    </Table.HeaderCell>
                    <Table.HeaderCell
                      style={{
                        backgroundColor: "#337ab7",
                        color: "white",
                      }}
                    >
                      Payment Date
                    </Table.HeaderCell>
                    <Table.HeaderCell
                      style={{
                        backgroundColor: "#337ab7",
                        color: "white",
                      }}
                    >
                      View
                    </Table.HeaderCell>
                  </Table.Row>
                </Table.Header>
                <Table.Body>
                  {paymentNotification ? (
                    paymentNotification.map((item, index) => (
                      <Table.Row>
                        <Table.Cell
                          style={{
                            padding: "10px",
                          }}
                        >
                          {item.buyerCompany}
                        </Table.Cell>
                        <Table.Cell>{item.payment}</Table.Cell>
                        <Table.Cell>{item.chequePaymentDate}</Table.Cell>
                        <Table.Cell>
                          <Button
                            primary
                            style={{
                              padding: "3px",
                              marginLeft: "10px",
                              paddingLeft: "10px",
                              paddingRight: "10px",
                            }}
                            onClick={() =>
                              navigate(
                                `/create-purchase/${item.purchaseId}/${item.categoryId}`
                              )
                            }
                          >
                            View
                          </Button>
                        </Table.Cell>
                      </Table.Row>
                    ))
                  ) : (
                    <Table.Row>
                      <Table.Cell>No Record Found</Table.Cell>
                    </Table.Row>
                  )}
                </Table.Body>
              </Table>
            )}
            {tableType == 2 && (
              <>
                <Grid.Row>
                  <Grid columns="five">
                    <Grid.Row>
                      <Form.Group>
                        <div
                          style={{
                            display: "flex",
                          }}
                        >
                          <div
                            style={{
                              marginRight: "20px",
                            }}
                          >
                            <Form.Field>
                              <Radio
                                label="5 days"
                                name="radioGroup"
                                value="1"
                                checked={radioValue === "1"}
                                onChange={() => getExpiryDocList("1")}
                              />
                            </Form.Field>
                          </div>
                          <div
                            style={{
                              marginRight: "20px",
                            }}
                          >
                            <Form.Field>
                              <Radio
                                label="15 Days"
                                name="radioGroup"
                                value="2"
                                checked={radioValue === "2"}
                                onChange={() => getExpiryDocList("2")}
                              />
                            </Form.Field>
                          </div>
                          <div
                            style={{
                              marginRight: "20px",
                            }}
                          >
                            <Form.Field>
                              <Radio
                                label="30 days"
                                name="radioGroup"
                                value="3"
                                checked={radioValue === "3"}
                                onChange={() => getExpiryDocList("3")}
                              />
                            </Form.Field>
                          </div>
                          <div
                            style={{
                              marginRight: "20px",
                            }}
                          >
                            <Form.Field>
                              <Radio
                                label="Already Expired"
                                name="radioGroup"
                                value="0"
                                checked={radioValue === "0"}
                                onChange={() => getExpiryDocList("0")}
                              />
                            </Form.Field>
                          </div>
                        </div>
                      </Form.Group>
                    </Grid.Row>
                  </Grid>
                </Grid.Row>

                <Table celled fixed singleLine>
                  <Table.Header>
                    <Table.Row>
                      <Table.HeaderCell
                        style={{
                          backgroundColor: "#337ab7",
                          color: "white",
                        }}
                      >
                        Name
                      </Table.HeaderCell>
                      <Table.HeaderCell
                        style={{
                          backgroundColor: "#337ab7",
                          color: "white",
                        }}
                      >
                        Exp Date
                      </Table.HeaderCell>
                      <Table.HeaderCell
                        style={{
                          backgroundColor: "#337ab7",
                          color: "white",
                        }}
                      >
                        File Type
                      </Table.HeaderCell>
                      <Table.HeaderCell
                        style={{
                          backgroundColor: "#337ab7",
                          color: "white",
                        }}
                      >
                        Days Remaining
                      </Table.HeaderCell>
                    </Table.Row>
                  </Table.Header>
                  <Table.Body>
                    {documentExpiry ? (
                      documentExpiry.map((item, index) => (
                        <Table.Row>
                          <Table.Cell
                            style={{
                              padding: "10px",
                            }}
                          >
                            {item.companyName}
                          </Table.Cell>
                          <Table.Cell>{item.fileExpiry}</Table.Cell>
                          <Table.Cell>{item.fileType}</Table.Cell>
                          <Table.Cell>{item.nofDaysToExpiry}</Table.Cell>
                        </Table.Row>
                      ))
                    ) : (
                      <Table.Row>
                        <Table.Cell>No Record Found</Table.Cell>
                      </Table.Row>
                    )}
                  </Table.Body>
                </Table>
              </>
            )}
          </div>
        </Sidebar>
        <Sidebar.Pusher>
          <Grid padded>
            <SideBarComp />
            <Grid.Column
              mobile={16}
              tablet={13}
              computer={13}
              floated="right"
              id="content"
            >
              <Outlet />
            </Grid.Column>
          </Grid>
        </Sidebar.Pusher>
      </Sidebar.Pushable>
      <div
        style={{
          marginRight: "20px",
        }}
      >
        <Grid padded className="tablet computer only">
          <Menu olive fluid fixed="bottom" bo>
            <Menu.Menu
              position="right"
              style={{
                marginRight: "30px",
              }}
            >
              <Menu.Item
                onClick={() => {
                  getExpiryPaymentList();
                  setVisible(true);
                }}
              >
                <div
                  style={{
                    backgroundColor: "#337ab7",
                    color: "white",
                    padding: 2,
                    fontWeight: "bold",
                    fontSize: "20px",
                    borderRadius: "10px",
                    padding: "10px",
                  }}
                >
                  Payment Notification ({paymentNotification.length})
                </div>
              </Menu.Item>
              <Menu.Item onClick={() => getExpiryDocList()}>
                <div
                  style={{
                    backgroundColor: "#337ab7",
                    color: "white",
                    padding: 2,
                    fontWeight: "bold",
                    fontSize: "20px",
                    borderRadius: "10px",
                    padding: "10px",
                  }}
                >
                  Expiry Document
                </div>
              </Menu.Item>
            </Menu.Menu>
          </Menu>
        </Grid>
      </div>
    </div>
  );
};

export default ContainerComp;
